"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
;
/**
 * The Event class is used as the base class for the creation of Event objects
 *
 * @export
 * @class Event
 * @implements {IEvent}
 */
class Event {
  /**
   * Creates an `Event` object for the specified event.
   *
   * @param {string} type
   * @param {boolean} [bubbles=false]
   * @param {boolean} [cancellable=false]
   * @param {*} [data=null]
   * @memberof Event
   */
  constructor(type) {
    let bubbles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let cancellable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    let data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    /**
     * The event target.
     *
     * @type {*}
     * @memberof Event
     */
    this.target = null;
    /**
     * The object that is actively processing the Event object with an event listener.
     *
     * @type {*}
     * @memberof Event
     */
    this.currentTarget = null;
    /**
     * Indicates whether an event is a bubbling event.
     *
     * @type {boolean}
     * @memberof Event
     */
    this.bubbles = false;
    /**
     * Indicates whether the behavior associated with the event can be cancelled.
     *
     * @type {boolean}
     * @memberof Event
     */
    this.cancellable = false;
    this.isPropagationStopped = false;
    this.type = type;
    this.bubbles = bubbles;
    this.cancellable = cancellable;
    this.data = data;
    this.defaultPrevented = false;
  }
  /**
   * Returns a JSON object representation of the event.
   *
   * @returns {EventObject}
   * @memberof Event
   */
  toJSON() {
    return {
      type: this.type,
      data: this.data
    };
  }
  /**
   * Prevents processing of any event listeners in nodes subsequent to the current node in the
   * event flow.
   *
   * @memberof Event
   */
  stopPropagation() {
    this.isPropagationStopped = true;
  }
  /**
   * Prevents processig of any event listeners in the current node and any subsequent nodes in
   * the event flow.
   *
   * @memberof Event
   */
  stopImmediatePropagation() {
    this.stopPropagation();
    this.isPropagationStopped = true;
  }
  /**
   * Checks whether the `preventDefault()` method has been called on the event.
   *
   * @returns {boolean}
   * @memberof Event
   */
  isDefaultPrevented() {
    return this.defaultPrevented;
  }
  /**
   * Cancels an event's default behavior if that behavior can be cancelled.
   *
   * @memberof Event
   */
  preventDefault() {
    this.defaultPrevented = true;
  }
}
var _default = exports.default = Event;
module.exports = exports.default;